import { Field, DropSelect } from '@/components/booking/ManagedParts';
import { bt } from '@/i18n/bookingI18n';
import { AIRPORTS, CITY_LOCATIONS } from '@/data/transportPricing';

const CITY_OPTIONS = CITY_LOCATIONS.map((l, i) => ({ value: String(i), label: l }));
const zoneLabel = (z) => `${z.name} — ${z.areas.slice(0, 42)}${z.areas.length > 42 ? '…' : ''}`;

export function AirportRouteFields({ airport, airportId, onAirport, zoneId, onZone, errors, lang }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
      <Field label={bt(lang, 'airportLabel')}>
        <DropSelect testid="transfer-airport" value={airportId} onChange={onAirport} placeholder={bt(lang, 'selectAirport')} options={AIRPORTS.map((a) => ({ value: a.id, label: a.name }))} />
      </Field>
      <Field label={bt(lang, 'destZone')} error={errors.zone}>
        <DropSelect testid="transfer-zone" value={zoneId} onChange={onZone} placeholder={bt(lang, 'selectArea')} options={airport.zones.map((z) => ({ value: z.id, label: zoneLabel(z) }))} />
      </Field>
    </div>
  );
}

export function CityRouteFields({ fromIdx, onFrom, toIdx, onTo, errors, lang }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
      <Field label={bt(lang, 'pickupArea')} error={errors.from}>
        <DropSelect testid="transfer-from" value={fromIdx} onChange={onFrom} placeholder={bt(lang, 'fromPh')} options={CITY_OPTIONS} />
      </Field>
      <Field label={bt(lang, 'dropoffArea')} error={errors.to}>
        <DropSelect testid="transfer-to" value={toIdx} onChange={onTo} placeholder={bt(lang, 'toPh')} options={CITY_OPTIONS} />
      </Field>
    </div>
  );
}
